export const chartOptions = {
  //aspectRatio: 1.2,
  animation: false,
  maintainAspectRatio: true,
  responsive: true,
  elements: {
    point: {
      radius: 0
    }
  },
  showTooltips: false,
  legend: {
    display: false
  },
  title: {
    display: false
  },
  scales: {
    xAxes: [
      {
        time: {
          unit: "day",
          displayFormats: {
            month: "dd"
          },
          // max: moment(labels[0]).format("dd"),
          // min: moment(labels[labels.length - 1]).format("dd")
        },
        ticks: {
          display: false,
          tickMarkLength: 0,
          mirror: true
        },
        gridLines: {
          display: false,
          drawBorder: false,
          drawTicks: false
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          display: false,
          tickMarkLength: 0,
          mirror: true
        },
        gridLines: {
          display: false,
          drawBorder: false,
          drawTicks: false
        }
      }
    ]
  },
  legend: {
    display: false
  },
  tooltips: {
    enabled: false,
    mode: "index",
    intersect: false,
    // custom: customTooltips
  },
  hover: {
    intersect: false
  },
  layout: {
    padding: {
      top: 5,
      left: 0,
      right: 0,
      bottom: -20
    }
  },
};
